"use client"

import { useAtomValue } from "jotai"
import { useContext } from "react"
import { useTranslation } from "react-i18next"

import LoginStateContext from "@/shared-module/common/contexts/LoginStateContext"
import withErrorBoundary from "@/shared-module/common/utils/withErrorBoundary"
import { Infobox, LoadingRegion } from "@/shared-module/components"
import { courseMaterialAtom } from "@/state/course-material"

import type { BlockRendererProps } from "../.."
import ChapterProgress from "./ChapterProgress"

const ChapterProgressBlock: React.FC<React.PropsWithChildren<BlockRendererProps<unknown>>> = () => {
  const { t } = useTranslation()
  const courseMaterialState = useAtomValue(courseMaterialAtom)
  const loginStateContext = useContext(LoginStateContext)

  if (courseMaterialState.status !== "ready" || loginStateContext.isLoading) {
    return <LoadingRegion />
  }
  if (!loginStateContext.signedIn) {
    return <Infobox>{t("please-log-in-to-see-your-progress")}</Infobox>
  }

  if (!courseMaterialState.instance) {
    return <div>{t("title-select-course-version-to-see-your-progress")}</div>
  }
  if (!courseMaterialState.page?.chapter_id) {
    return <div>{t("error-page-does-not-belong-to-chapter")}</div>
  }

  return (
    <ChapterProgress
      courseInstanceId={courseMaterialState.instance.id}
      chapterId={courseMaterialState.page.chapter_id}
    />
  )
}

export default withErrorBoundary(ChapterProgressBlock)
